import { getUrlPrefix } from '~/lang/locales'
import { datepickerAvailabilityResultsSchema } from './schemas'
import { DatepickerAvailabilityResultsDay } from './types'
import {
  DatepickerFetchError,
  DatepickerValidationError,
} from './DatepickerError'

// Default timeout for datepicker requests (30 seconds)
const DATEPICKER_TIMEOUT = 30000

export class DatepickerAvailabilityServiceFetch {
  async get(
    langCode: string,
    slug: string,
    categories: Array<string> = [],
    pitchtypeId?: string,
  ): Promise<DatepickerAvailabilityResultsDay[]> {
    const params = categories.reduce((categoryParams, id) => {
      categoryParams.append('type', String(id))
      return categoryParams
    }, new URLSearchParams())
    if (pitchtypeId) {
      params.append('pitchtype_id', String(pitchtypeId))
    }
    const urlPrefix = getUrlPrefix(langCode)
    const url = `/_/fallback${urlPrefix}/_/datepicker/${slug}${params.size ? '?' + params.toString() : ''}`

    let response: any

    // Step 1: Fetch the data
    try {
      response = await $fetch(url, {
        timeout: DATEPICKER_TIMEOUT,
      })
    } catch (error: any) {
      // Silently return empty array for abort errors - they're intentional cancellations
      if (error?.name === 'AbortError' || error?.message?.includes('aborted')) {
        return []
      }
      const fetchError = new DatepickerFetchError(
        url,
        slug,
        categories,
        pitchtypeId,
        error,
      )
      // Don't log here - let the store handle logging to avoid duplicates
      throw fetchError
    }

    // Step 2: Validate with Zod schema
    try {
      return datepickerAvailabilityResultsSchema.parse(
        response,
      ) as DatepickerAvailabilityResultsDay[]
    } catch (error: any) {
      const validationError = new DatepickerValidationError(
        url,
        slug,
        categories,
        pitchtypeId,
        response,
        error,
      )
      // Don't log here - let the store handle logging to avoid duplicates
      throw validationError
    }
  }
}
